import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { routes } from 'app/constants';
import BackToPipelineOverviewButton from 'app/components/BackToPipelineOverviewButton';
import SharedBackButton from 'app/shared/navigation/BackButton';

export default function BackButton({ pipelineId, name, isResultsPage }) {
  const history = useHistory();

  // From the summary, back means the configuration you just built from — the
  // pipeline overview is two steps away and leaves no route back to the form.
  if (isResultsPage) {
    const { writekey, clusterId, clusterName, referrer } = history.location.state ?? {};
    return (
      <SharedBackButton
        to={{
          pathname: routes.analyticsJSBuilder,
          state: { pipelineId, name, writekey, clusterId, clusterName, referrer },
        }}
      >
        Back to Configuration
      </SharedBackButton>
    );
  }

  return <BackToPipelineOverviewButton pipelineId={pipelineId} pipelineName={name} />;
}

BackButton.propTypes = {
  pipelineId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isResultsPage: PropTypes.bool,
};
